import { styled } from '@mui/material/styles';
import { isRtl } from 'common/utils/utils';

export const StyledTable = styled('div')(({ theme }) => ({
  height: '320px',
  maxHeight: '400px',
  width: '80vw',
  maxWidth: '1400px',
  minWidth: '800px',
  overflow: 'auto',

  '& ::-webkit-scrollbar': {
    width: '26px',
    height: '26px',

    '&-track': {
      visibility: 'hidden',
    },

    '&-thumb': {
      backgroundColor: theme.palette.grey.bt_alt_grey_hover,
      borderRadius: '20px',
      height: '500px',
      border: '11px solid #fff',
      '&:hover': {
        backgroundColor: theme.palette.grey.bt_def_grey_light,
      },
    },
  },
  '@supports (scrollbar-color: #e1e2e5 #fff)': {
    '& .ag-body-viewport, & .ag-body-horizontal-scroll-viewport, & .ag-body-vertical-scroll-viewport': {
      scrollbarColor: `${theme.palette.grey.bt_alt_grey_hover} ${theme.palette.generic.primary}`,
      scrollbarWidth: 'thin',
      scrollbarGutter: 'stable',
    },
  },

  '& .ag-row': {
    color: `${theme?.palette?.text?.secondary_txt}!important`,
  },

  '& .ag-row-odd': {
    backgroundColor: 'transparent!important',
  },

  '& .ag-cell': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'center',
    lineHeight: 'normal',
    border: 'none!important',
    paddingLeft: '0px!important',
    paddingRight: '0px!important',
    '& > div': {
      paddingLeft: '2px!important',
    },

    '& > div[data-field-type="SELECT"], & > div[data-field-type="MULTISELECT"]': {
      paddingLeft: '8px',
    },
    '& > div[data-field-type="NUMBER"]': {
      paddingLeft: '0px',
      '& > span[data-field-type="text-with-tooltip"]': {
        paddingLeft: '8px',
      },
    },
    '& > div[data-field-type="DATEANDTIME"]': {
      paddingLeft: '0px !important',
      '& > span[data-field-type="text-with-tooltip"]': {
        paddingLeft: '8px',
      },
    },
    '& > div[data-field-type="TEXT"], & > div[data-field-type="LONGTEXT"]': {
      paddingLeft: '6px!important',
      '& > span[data-field-type="text-with-tooltip"]': {
        paddingLeft: '2px',
      },
      '& > .MuiTextField-root': {
        backgroundColor: 'transparent',
      },
    },

    '&[col-id="checkbox"]': {
      justifyContent: 'center!important',
      paddingLeft: '10px!important',
    },
    '&[col-id="status"] > div': {
      marginLeft: '-2px',
    },
    '&[col-id="srType"] > div': {
      paddingLeft: '0px!important',
    },
    '&[col-id="id"] > div': {
      paddingLeft: '7px!important',
    },
    '&[col-id="assignee"] > div': {
      paddingLeft: '4px!important',
      '& > div': {
        width: 'unset!important',
        maxWidth: '100%',
        marginLeft: '2px',
        '&> div.assignees > span.assignee-tooltip-wrapper': {
          maxWidth: '100%',
        },
      },
    },
  },

  '& .ag-root-wrapper': {
    borderRadius: '4px',
    border: `1px solid ${theme?.palette?.grey.divider_grey_v1}`,
  },

  '& .ag-row-hover:not(.ag-full-width-row)::before, .ag-row-hover.ag-full-width-row.ag-row-group::before': {
    backgroundColor: `${theme.palette.background.row_hover} !important`,
    backgroundImage: 'unset',
  },
  
  '& .ag-row-selected::before, .ag-row-hover.ag-row-selected::before': {
    backgroundColor: `${theme.palette.background.selected}!important`,
  },

  '& .ag-cell-focus:focus-within': {
    outline: 'none!important',
    border: 'none!important',
  },

  '& .ag-theme-alpine .ag-row-hover': {
    backgroundColor: `${theme.palette.background.row_hover} !important`,
    border: 'none !important',
    boxShadow: 'none !important',
  },

  '& .ag-theme-alpine .ag-row': {
    borderWidth: '0px',
    borderTop: '1px solid #ABAEB3',
    height: '64px',
    backgroundColor: theme.palette.generic.primary,

    '& *': {
      fontSize: '12px',
    },

    '::before': {
      background: 'none',
      backgroundColor: 'none',
    },
  },
  '& .ag-header-cell': {
    paddingLeft: '8px',
    paddingRight: '8px',
    backgroundColor: '#F5F6FA',
  },

  '& .ag-header': {
    borderBottom: `1px solid ${theme?.palette?.grey.divider_grey_v1}`,
    flexDirection: 'row !important',
    backgroundColor: theme.palette.grey.bt_alt_grey_light,
    '& .ag-pinned-left-header': {
      border: isRtl(theme.direction) && 0,
    },
    '& *': {
      fontSize: '14px',
      fontWeight: 400,
    },

    '& .checkboxClassName': {
      paddingRight: '0',
    },
  },

  '& .ag-body-viewport': {
    width: 'calc(100% + 10px)!important'
  }
}));

export const CellComponentWrapper = styled('div')(({ theme }) => ({
  maxWidth: '100%',
  color: `${theme?.palette?.text?.secondary_txt}!important`,
  font: '"Roboto-Regular","Open Sans",Arial,sans-serif',
  fontSize: '14px',
  lineHeight: '20px',
  display: 'flex',
  alignItems: 'center',
  fontWeight: '400!important',
}));
